// src/utils/listingFormat.ts

export function formatINR(amount: number): string {
  return `\u20B9${new Intl.NumberFormat("en-IN").format(Math.round(amount))}`;
}

export function formatDate(iso: string): string {
  if (!iso) return "";
  return new Date(iso).toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

export function availabilityLabel(from: string, to: string): string {
  const today = new Date();
  const f = new Date(from);
  const t = new Date(to);
  if (today < f) return `Available from ${formatDate(from)}`;
  if (today >= f && today <= t) return `Available now \u00B7 till ${formatDate(to)}`;
  return "Booking closed";
}

/** Some listings in this dataset have (0,0) or out-of-range lat/lng placeholders — guard before rendering a map link. */
export function hasValidCoordinates(lat: number, lng: number): boolean {
  if (lat == null || lng == null) return false;
  if (lat === 0 && lng === 0) return false;
  return Math.abs(lat) <= 90 && Math.abs(lng) <= 180 && Math.abs(lat) > 0.0001;
}

export function googleMapsLink(lat: number, lng: number): string {
  return `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
}

export function locationTone(name: string | null): string {
  if (!name) return "bg-slate-100 text-slate-600 border border-slate-200";
  if (name.startsWith("A+")) return "bg-orange-50 text-[#C23A1F] border border-orange-100";
  if (name.startsWith("B")) return "bg-blue-50 text-[#1170A3] border border-blue-100";
  return "bg-slate-100 text-slate-600 border border-slate-200";
}

export const MEDIA_TYPE_LABELS: Record<string, string> = {
  hoarding: "Hoarding",
  unipole: "Unipole",
  led_screen: "LED Screen",
  gantry: "Gantry",
  transit_media: "Transit Media",
  mall_kiosk: "Mall Kiosk",
  wall_wrap: "Wall Wrap",
};

export function mediaTypeLabel(value: string): string {
  return MEDIA_TYPE_LABELS[value] ?? value;
}

export const MEDIA_TYPE_OPTIONS = Object.entries(MEDIA_TYPE_LABELS).map(([value, label]) => ({
  value,
  label,
}));

export const PRICE_BOUNDS: [number, number] = [0, 300000];

export const PAGE_SIZE = 20;